import isDeepEqualReact from 'fast-deep-equal/react';
export default isDeepEqualReact;



//////////////////
// WEBPACK FOOTER
// ./~/react-use/esm/misc/isDeepEqual.js
// module id = 766
// module chunks = 2